//React
import React from "react";
import {
  Link,
} from "react-router-dom";
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as footprintAction from '../action/footprintAction';
import * as partnerOperationAction from '../action/partnerOperationAction';
import * as helpAction from '../action/helpAction';
import * as uiAction from '../action/uiAction';
//Material-ui
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import Avatar from '@material-ui/core/Avatar';
import AvatarGroup from '@material-ui/lab/AvatarGroup';
//Add
import Masonry from 'react-masonry-component';
import Blank from '../img/blank/blank-1x1.gif';
//Func
import atom2datetime from '../func/atom2datetime';
//Part
import Button from '@material-ui/core/Button';
import MenuSearch from './MenuSearch';
import MenuFootprint from './MenuFootprint';
import PartUserName from './PartUserName';
import PartUserMainImg from './PartUserMainImg';
import PartTimeIcon from './PartTimeIcon';
import PartPagingNextPrev from './PartPagingNextPrev';

//Icon
import RefreshIcon from '@material-ui/icons/Refresh';
import MoreVertSharpIcon from '@material-ui/icons/MoreVertSharp';


class Comp extends React.Component {
  constructor(props) {
    super(props);
  	this.state = {

  	}
  }
  componentDidMount() {
    document.title = '足あと(相手から) - パートナーズ';
    if (this.props.history.action === 'PUSH' || !this.props.footprint.partner.datetime) {
      this.props.footprintPartnerListGet(1);
      window.scrollTo(0, 0);
    }
  }

  _paging(page) {
    this.props.footprintPartnerListGet(page);
    window.scrollTo(0, 0);
  }

  _renderList = (item, index) => {
		return (
      <div key={index} className='box_outer'>
        <Box className='box_innner round12' boxShadow={2}>
          <div style={{position:'absolute', top:'0px', right:'0px'}}>
            <IconButton
              onClick={ () => this.props.partnerOperationOpen(item.userdata_id_code, ['footprintPartnerDel', 'memo', 'refusal']) }
            >
              <MoreVertSharpIcon />
            </IconButton>
          </div>
          <div style={{padding:'2%'}}>
            <div style={{textAlign:'center'}}>
              <Link to={{ pathname: '/partner/' + item.userdata_id_code}}>
                <PartUserName
                  data={{
                    name: item.userdata_name,
                    sex: item.userdata_sex,
                    size: '1.4em',
                  }}
                />
              </Link>
              <div>
                {item.userdata_age}才 {item.userdata_prof_region} {item.userdata_prof_region_detail}
              </div>
            </div>
            <div className='box_left'>
              <div style={{margin:'1%'}}>
                <Link to={{ pathname: '/partner/' + item.userdata_id_code}}>
                  <div align='center'>
                    <PartUserMainImg
                      mainImg={item.userdata_mainImg}
                      maxWidth={'160px'}
                      width={'100%'}
                      height={'auto'}
                      radius={'50%'}
                      lazyLoad={false}
                    />
                  </div>
                </Link>

              </div>
            </div>
            <div className='box_right'>
              {
                (item.userdata_prof_partner_comment.length > 0) &&
                <div
                  className='comment round12'
                  style={{fontSize:'0.9em', color:'#666', margin:'1%'}}
                >
                  {item.userdata_prof_partner_comment}
                </div>
              }

              { (item.userdata_proof_person === 1) && (<span className='proof_icon'>本人証明</span>) }
              { (item.userdata_proof_photo === 1) && (<span className='proof_icon'>写真証明</span>) }
              { (item.userdata_proof_income === 1) && (<span className='proof_icon'>収入証明</span>) }
              { (item.userdata_proof_single === 1) && (<span className='proof_icon'>独身証明</span>) }
              { (item.userdata_proof_credit === 1) && (<span className='proof_icon'>ｸﾚｼﾞｯﾄ証明</span>) }
              { (item.post_count > 0) && (<span className='post_icon'>投稿 {item.post_count}件</span>) }
              { (item.qa_count > 0 || item.qa_answer_count > 0) && (
                <span className='qa_icon'>Q&A
                  { (item.qa_count > 0) && (item.qa_count + '問')}
                  { (item.qa_answer_count > 0) && (item.qa_answer_count + '答')}
                </span>
              ) }
              { (item.character_type16) && (<span className='personality_icon'>性格</span>) }
            </div>

            <div style={{clear:'both'}} />

            <div style={{textAlign:'center'}}>
              <span
                onClick={ (event) => this.props.popoverOpen(event.currentTarget, 'あなたのプロフィールを閲覧した時間') }
              >
                <PartTimeIcon
                  text={atom2datetime(item.footprint_datetime_atom, 'DT') + ' の足あと'}
                />
              </span>
            </div>
          </div>

        </Box>
      </div>
    );
  };


  render() {
    return (
      <div>
        <MenuSearch />

        <MenuFootprint />

        <div
          style={{
            display:'flex',
            flexDirection:'row',
            alignItems:'center',
            justifyContent: 'space-between',
            margin: '10px',
          }}
        >
          <div>
          </div>
          <div>
            <span style={{color:'#666'}}>ページ{this.props.footprint.partner.page}</span>

            <IconButton
              onClick={ () => this.props.footprintPartnerListGet(1) }
            >
              <RefreshIcon />
            </IconButton>
          </div>
        </div>
        {
          (this.props.footprint.partner.datetime) && (
            (this.props.footprint.partner.count > 0) ? (
              (this.props.my.proof.credit === 0 && this.props.my.proof.person === 0) ? (
                <div align='center'>
                  <h2 align='center' style={{padding:'10px'}}>
                    あなたのプロフィールを<br/>
                    閲覧した方が{ this.props.footprint.partner.count }人います
                  </h2>
                  <div style={{display:'inline-block', position:'relative'}}>
                    <AvatarGroup spacing='small' max={100} >
                    {
                      this.props.footprint.partner.list.filter(value => value.userdata_mainImg.src !== null).map(
                        (value, index) => {
                      		return (
                            <Avatar
                              key={index}
                              src={value.userdata_mainImg.src}
                            />
                          )
                        }
                      )
                    }
                    </AvatarGroup>
                    <img
                      src={Blank}
                      style={{
                        position:'absolute',
                        left:0,
                        top:0,
                        width:'100%',
                        height:'100%',
                        zIndex:10000
                      }}
                      alt=''
                    />
                  </div>
                  <h3 align='center'>
                    <span className='i-b'>足あとは本人証明を</span>
                    <span className='i-b'>提出いただくと表示されます</span>
                  </h3>
                  <div align='center' style={{padding:'10px'}}>
                    <Button
                      variant="contained"
                      color='secondary'
                      onClick={ () => this.props.history.push('/my/proof/person') }
                      style={{fontSize:'1.2em'}}
                    >
                      本人証明を申請する
                    </Button>
                  </div>
                </div>
              ) : (
                <div id="user_list_block">
                  {
                    (this.props.footprint.partner.datetime) && (
                      (this.props.footprint.partner.list.length > 0) ? (
                        <div>
                          <Masonry options={{
                            itemSelector: '.box_outer',
                            transitionDuration: 0,
                          }}>
                            {
                              this.props.footprint.partner.list.map(
                                (value, index) => this._renderList(value, index)
                              )
                            }
                          </Masonry>
                          <div style={{margin:'15px'}}>
                            <PartPagingNextPrev
                              page={this.props.footprint.partner.page}
                              isNext={this.props.footprint.partner.isListNext}
                              onClick={ (e) => this._paging(e) }
                            />
                          </div>
                        </div>
                      ) : (
                        <h2 align='center' style={{padding:'30px 0px'}}>
                          <div>お相手からの足あとは</div>
                          <div>見つかりませんでした</div>
                        </h2>
                      )
                    )
                  }

                </div>
              )
            ):(

              <h2 align='center' style={{padding:'30px 0px'}}>
                <div>お相手からの足あとは</div>
                <div>見つかりませんでした</div>
              </h2>

            )
          )
        }

        <div align='center' style={{margin:'15px'}}>
          <Button
            color="primary"
            variant={ "outlined" }
            onClick={ () => this.props.helpOpen('category','footprint') }
          >
            「足あと」とは？
          </Button>
        </div>

      </div>
    )
  }
}

const mapStateToProps = (state) => {
	return {
    footprint: state.footprint,
    my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...footprintAction,
    ...partnerOperationAction,
    ...helpAction,
    ...uiAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
